import React from "react";
import { Container } from "@mui/material";
import PostManagementTable from "../PostManagementTable";

const PublishedPostsSection = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <PostManagementTable 
        title="Posts Publicados" 
        defaultStatus="published" 
      />
    </Container>
  );
};

export default PublishedPostsSection;